<template>
  <div>
    <div class="portlet light">
      <div class="module-name">Communication Notes</div>
      <div class="portlet-title">
        <div class="caption caption-md">
          <i class="icon-bar-chart font-dark hide"></i>
          <span class="caption-subject font-dark bold uppercase">Communication Notes</span>
        </div>
      </div>
      <vue-spinner v-if="getLoading"></vue-spinner>
      <div class="portlet-body" style="height: 566px; overflow: hidden;" v-else v-bar>
        <div class="general-item-list" v-if="showLoop(user.case_notes)">
          <div class="item" v-for="casenote in user.case_notes">
            <div class="item-head">
              <span style="color: #d09f23" v-if="casenote.type === 'referral' || casenote.read_only">
              {{ note[casenote.type] }}</span>
              <a v-else @click.prevent="editNoteAction(casenote)">{{ note[casenote.type] }} </a>
              <i class="fa fa-thumb-tack pin inactivePin" aria-hidden="true"  v-bind:class="{ 'activePin' : checkPin(casenote.is_pinned) }"  @click="setPin(casenote.id,casenote.is_pinned)" ></i>
            </div>
            <div class="item-body casenote-title" v-html="excerpt(casenote.note, 150)"></div>
            <ul class="casenotes">
              <li>
                <div class="col1">
                  <div class="cont">
                    <div class="cont-col2">
                      <div class="date">{{ casenote.createdAt.date | formatDate }}</div>
                    </div>
                  </div>
                </div>
                <div class="col2">
                  <div class="name"> {{ casenote.createdBy.fullName }}</div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div v-else>
          <p>No records available.</p>
        </div>
      </div>

      <div class="btn-arrow-link pull-right">
        <a class="Link text-warning" v-if="showLoop(user.case_notes)" @click="showAll">VIEW ALL</a>
        <span v-if="showLoop(user.case_notes) && logged.access > 2">|</span>
        <a class="Linkt text-warning" @click="addNew" v-if="logged.access > 2 && programStatus !== 'Dismissed'"> NEW </a>
        <i class="icon-arrow-right" v-if="logged.access > 2 && programStatus !== 'Dismissed'"></i>
      </div>
      <div class="clearfix"></div>
    </div>
    <div id="case-notes" class="modal fade" role="dialog" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true"></button>
            <h4 class="modal-title uppercase">Communication Notes</h4>
            <div class="actions pull-right">
              <a class="btn btn-circle btn-icon-only btn-default" @click.prevent="downloadReport">
                <i class="icon-cloud-download"></i>
              </a>
            </div>
          </div>
          <div class="modal-body">
            <div class="row">
              <form class="form-horizontal" role="form" @submit.prevent="onSearchNotes">
                <div class="form-body">
                  <div class="col-md-12">
                    <div class="input-group">
                      <div class="input-group-control input-icon">
                        <i class="fa fa-search"></i>
                        <input type="text" class="form-control" placeholder="Type to search..." v-model="search">
                        <div class="form-control-focus"></div>
                      </div>
                      <span class="input-group-btn btn-right">
                   <button class="btn green mt-ladda-btn ladda-button btn-search" ref="searchBtn" type="submit" data-style="expand-left">
                      <span class="ladda-label">Search</span>
                   </button>
                </span>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div class="row">
              <div class="col-md-12" style="min-height: 400px; overflow: hidden;" v-bar>
                <div class="general-item-list">
                  <div class="item" v-for="casenote in allNotes.data">
                    <div class="item-head">
                      <a href="" @click.prevent="editNoteAction(casenote)">{{ note[casenote.type] }}</a>
                          <i class="fa fa-thumb-tack pin inactivePin" aria-hidden="true"  v-bind:class="{ 'activePin' : checkPin(casenote.is_pinned) }"  @click="modalSetPin(casenote.id,casenote.is_pinned)"></i>
                    </div>
                    <div class="item-body casenote-title" v-html="casenote.note"></div>
                    <ul class="casenotes">
                      <li>
                        <div class="col1">
                          <div class="cont">
                            <div class="cont-col2">
                              <div class="date">{{ casenote.createdAt.date | formatDate }}</div>
                            </div>
                          </div>
                        </div>
                        <div class="col2">
                          <div class="name"> {{ casenote.createdBy.fullName }}</div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="col-md-12 text-center">
                <pagination
                    :page-count="allNotes.hasOwnProperty('pages') ? allNotes.pages : 0"
                    :page-range="1"
                    :margin-pages="1"
                    :click-handler="changePage"
                    :prev-text="'Prev'"
                    :next-text="'Next'"
                    :container-class="'pagination pagination-sm'">
                </pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="new-case-notes" class="modal fade" role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-sm">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true"></button>
            <h4 class="modal-title">ADD COMMUNICATION NOTE</h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="" class="control-label">Communication Type:</label>
                  <select class="form-control" v-model="caseNoteType">
                    <option value="collateral">Collateral Contact</option>
                    <option value="email">Email</option>
                    <option value="person">In-Person</option>
                    <option value="phone">Phone</option>
                    <option value="social">Social/Messenger</option>
                    <option value="text">Text</option>
                    <option value="virtual">Virtual</option>
                  </select>
                </div>
                <div class="form-group">
                  <label for="" class="control-label">Notes:</label>
                  <vue-editor v-model="caseNote" :editor-toolbar="customToolbar" />
                  <!-- <textarea class="form-control" v-model="caseNote" maxlength="5000" rows="10"
                            style="width:100%;"></textarea> -->
                  <!-- <p class="pull-right">{{ 5000 - caseNote.length }} Characters Remaining</p> -->
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn green mt-ladda-btn ladda-button add-casenote-control" data-dismiss="modal"
                    data-style="expand-left" @click.prevent="addCase" v-if="logged.access > 2">
              <span class="ladda-label">Save</span>
            </button>
            <button class="btn default" data-dismiss="modal">Cancel</button>
          </div>
        </div>
      </div>
    </div>
    <div id="edit-case-notes" class="modal fade" role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-sm">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true"></button>
            <h4 class="modal-title">EDIT COMMUNICATION NOTE</h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="" class="control-label">Communication Type:</label>
                  <select class="form-control" v-model="editNote.type">
                    <option value="collateral">Collateral Contact</option>
                    <option value="email">Email</option>
                    <option value="person">In-Person</option>
                    <option value="phone">Phone</option>
                    <option value="social">Social/Messenger</option>
                    <option value="text">Text</option>
                    <option value="virtual">Virtual</option>
                  </select>
                </div>
                <div class="form-group">
                  <label for="" class="control-label">Notes:</label>
                  <vue-editor v-model="editNote.note" :editor-toolbar="customToolbar" />
                  <!-- <textarea class="form-control" v-model="editNote.note" maxlength="5000" rows="10"
                            style="width:100%;"></textarea> -->
                  <!-- <p class="pull-right">{{ (editNote.note != null) ? 5000 - editNote.note.length : '' }} Characters
                    Remaining</p> -->
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn green mt-ladda-btn ladda-button edit-casenote-control" data-dismiss="modal"
                    data-style="expand-left" @click.prevent="editCase" v-if="logged.access > 2">
              <span class="ladda-label">Save</span>
            </button>
            <button class="btn default" data-dismiss="modal">Cancel</button>
            <div class="text-left" v-if="editNote.updatedAt != null">
              <h4>ACTIVITY LOGGING</h4>
              <p>Saved: {{ editNote.createdBy.fullName }} on {{ editNote.createdAt.date | formatDate }}</p>
              <p>Last Modified: {{ editNote.updatedBy.fullName }} on {{ editNote.updatedAt.date | formatDate }} </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {mapGetters, mapActions} from 'vuex';
  import Pagination from '@/components/Pagination.vue'
  import {excerpt} from '@/auth';
  import Spinner from '@/components/Spinner';
  import { VueEditor } from "vue2-editor";

  export default {
    data() {
      return {
        caseNote: '',
        caseNoteType: 'collateral',
        note: {
          collateral: 'Collateral Contact',
          email: 'Email',
          person: 'In-Person',
          phone: 'Phone',
          text: 'Text',
          referral: 'Referral',
          virtual: 'Virtual',
          social: 'Social/Messenger',
        },
         customToolbar: [
          ["bold", "italic", "underline","link"],
          [{ list: "ordered" }, { list: "bullet" }],
          [ "code-block"]
        ],
        page: 1,
        search: ''
      }
    },
    components: {
      'vue-spinner': Spinner,
      Pagination,
      VueEditor
    },
    computed: {
      ...mapGetters({
        logged: 'getUser',
        user: 'getParticipant',
        editNote: 'getEditNote',
        allNotes: 'getAllNotes',
        getLoading: 'getLoading',
      }),
      programStatus() {
        if (this.user.hasOwnProperty('assignment') && this.user['assignment'].length != 0)
          return this.user['assignment']['program_status'];
        if (this.user.hasOwnProperty('assignments') && this.user['assignments'].length != 0)
          return this.user['assignments'][0]['programStatus'];
        return ''
      },
    },
    methods: {
      ...mapActions({
        getNotes: 'GET_CASE_NOTE_ACTION',
        editNoteActionSet: 'EDIT_CASE_NOTE',
        addCaseNote: 'ADD_CASE_NOTE_ACTION',
        editCaseAction: 'EDIT_CASE_NOTE_ACTION',
        getReportCaseNotes: 'CASE_NOTES_REPORT_ACTION',
        addToFavorite:'ADD_TO_FAVORITE_NOTE'
      }),
      setPin(id,status){
        if(status == 1){
          status = 0;
        }else{
          status = 1;
        }
        var updateNotes = {
          "id" : id,
          "status" : status,
        }
         this.addToFavorite(updateNotes);


      },
        modalSetPin(id,status){
        if(status == 1){
          status = 0;
        }else{
          status = 1;
        }
        var updateNotes = {
          "id" : id,
          "status" : status,
        }
         this.addToFavorite(updateNotes);
         this.showAll();

      },
      checkPin(flag){
        // return true;
          if(flag == 1){
              return true;
          }else{
              return false;
          }
        }
        ,
      editNoteAction(context) {
        if (context.type == 'referral') {
          return;
        }
        $('#edit-case-notes').modal('show');
        this.editNoteActionSet(context);
      },
      addCase() {
        this.addCaseNote({type: this.caseNoteType, note: this.caseNote, id: this.$route.params.id, _this: this})
      },
      showLoop(data) {
        if (data != null)
          return (data.length > 0)
      },
      showAll() {
        this.search = ''; // clear search input
        this.getNotes({participant: this.$route.params.id, limit: 6, page: 1, search: this.search}).then( _res => {
          $('#case-notes').modal('show');
        });
      },
      addNew() {
        // reset previously entered values
        this.caseNoteType = 'collateral'
        this.caseNote = ''

        $('#new-case-notes').modal('show')
      },
      changePage(page) {
        this.getNotes({participant: this.$route.params.id, limit: 6, page: page, search: this.search});
      },
      excerpt(str, limit) {
        const body = str;
        let summary = new String(str);
        const cut = summary.lastIndexOf(' ', limit);
        const size = summary.substr(0, limit).length;
        if (size < limit) return body
        return summary = summary.substr(0, limit) + '...';
      },
      editCase() {
        const context = Ladda.create(document.querySelector('.edit-casenote-control'));
        this.editCaseAction(context);
      },
      downloadReport() {
        this.getReportCaseNotes({id: this.$route.params.id, timezone: this.logged.time_zone})
      },
      onSearchNotes() {
        const context = Ladda.create(document.querySelector('.btn-search'));
        context.start();
        this.getNotes({participant: this.$route.params.id, limit: 6, page: 1, search: this.search}).finally(()=> {
          context.stop();
        });
      }
    },
  }
</script>
<style>
  #new-case-notes, #edit-case-notes {
    right: 20px;
    left: initial;
    top: 60px;
  }

  #new-case-notes .modal-sm, #edit-case-notes .modal-sm {
    width: 400px;
  }

  @media only screen and (max-width: 440px) {
    #new-case-notes .modal-sm, #edit-case-notes .modal-sm {
      width: initial;
    }

    #new-case-notes, #edit-case-notes {
      right: 10px;
      width: 95%;
    }
  }

  #case-notes .modal-header button {
    margin-right: 10px;
  }

  #case-notes .modal-title {
    display: inline-block;
  }

  #case-notes .actions {
    margin-right: 20px;
  }

  .modal-footer p {
    margin: 3px 0;
  }

  .pin {
    float:right;
    cursor: pointer;
  }

   .activePin {
     color :#999999 !important;

  }

  .inactivePin {
    color :#d09f23;
  }


  .quillWrapper #quill-container .ql-editor p{
    font-family: "Open Sans", sans-serif;
    font-size: 14px;
  }
  .item-body.casenote-title p{
    margin-bottom: 0px;
  };

</style>



// WEBPACK FOOTER //
// CaseNotes.vue?68b86356